define([
	"dojo/_base/declare",
	"csi",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType",
	"./PurchasedOrderForm"
], function(declare,csi,New,ActionControllerMixin,xml,Query,ProductType) {

	return declare([New, ActionControllerMixin], {
		// Boolean: indicate that user should land on new node after node is created
		bNavigate: true,

		// Boolean: this controller overrides default writing of operations
		_bWrite: false,

		// Node: the Product to create PO for.
		_nodeProduct: null,

		FIELD_SALES_ORDER:"POSalesOrder",

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if on first page
			return !index;
		},

		disableNext: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if not on first page
			return !!index;
		},

		getFormData: function() {
			var	fd = this.inherited(arguments);
			fd.m_parentNode = this.m_cache.getNode(this.m_urlParent);
			if(fd.m_parentNode.$Type == "Style") {
				this._nodeProduct = fd.m_parentNode;
			}
			//fd.m_bRequireOne = true;
			return fd;
		},

		_isSKUBasedSO: function() {
			var salesOrderURL = this.m_formData.getFieldValue(this.FIELD_SALES_ORDER);
			var salesOrder = this.widget.getCache().getNode(salesOrderURL, true);
			var salesOrderUnreleased = this.widget.getCache().getNode(salesOrder.NonFrozen, true);
			return salesOrderUnreleased.SKUBasedOrder;
		},


		getWizardNumberOfRealizedPages: function(/*csi.wizard.Widget*/wizard) {
			// summary: override when wizard skips pages based on certain conditions and return the number of pages in wizard (must be constant)
			return 2;
		},
		
		getWizardRealizedPageIndex: function(/*csi.wizard.Widget*/wizard, /*Number*/index) {
			// summary: the first page is always shown, while only one of the 2nd or 3rd pages is shown based on color based ordering
			return index ? 1 : 0;
		},

		onPrevPage: function(/*csi.wizard.Widget*/wizard,
				 /*csi.wizard.Content*/currentPage,
				 /*csi.wizard.Content*/prevPage) {
			// summary: skip views not in use
			var	index = wizard.getIndexOfPage(prevPage);
			if (index == 1) {
				if (this._isSKUBasedSO()) {
					return wizard.skipToPrevPage(prevPage);
				}
			}
			return null;

		},
		
		onNextPage: function(/*csi.wizard.Widget*/wizard,
				 /*csi.wizard.Content*/currentPage,
				 /*csi.wizard.Content*/nextPage,
				 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			if(bFinish) return null;
			var fd = this.m_formData;
			// if one goes back and changes the SalesOrder reset the next page selections of SalesOrderLineItems
			var salesOrderField = fd.getField(this.FIELD_SALES_ORDER);
			if(salesOrderField && salesOrderField.isUpdated()) {
				fd.resetSelections();
			}

			var index = wizard.getIndexOfPage(nextPage);
			if (index == 1) {
				if (this._isSKUBasedSO()) {
					return wizard.skipToNextPage(nextPage);
				}
			}

			return wizard.setFormDataToPage(nextPage, fd, (wizard.getIndexOfPage(nextPage) == 1));
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: return query for SalesOrderLineItems from the selected SalesOrder
			// and if this action is on style, then also that have a colorway for this style
			if (index == 1 || index == 2) {
				var query = new Query();
				if (this._nodeProduct) {
					var path = this._isSKUBasedSO() ? "Child:SOLISKU" : "Child:SOLIColorway";
					query.RefAttr("__Parent__", xml.OP_EQUALS, this._nodeProduct.$URL, path);
				} else {
					if (!this._isSKUBasedSO()) {
						query.RefAttr("SOLIColorway", xml.OP_NOT_EQUALS, csi.EMPTY_URL);
					}
				}

				if (this._isSKUBasedSO()) {
					return query.RefAttr("__Parent__", xml.OP_EQUALS, this.m_formData.getFieldValue(this.FIELD_SALES_ORDER), "Child:__Parent__");
				} else {
					return query.RefAttr("__Parent__", xml.OP_EQUALS, this.m_formData.getFieldValue(this.FIELD_SALES_ORDER));
				}
			}

			return null;
		},

		toWriter: function() {
			this.inherited(arguments);

			var	call = this.m_writer.callMethod("Sourcing", "PONewFromSO")
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode);

			// add selected nodes - separated into own function so derived controllers can process them differently
			this.toWriterSelections(this.m_formData, call, null);

			return null;
		}
	});
});